module.exports = __webpack_public_path__ + "static/media/classic_cell_ring.01f40770.mp3";